var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"white"},[_c('v-content',{staticClass:"white"},[_c('v-container',{staticClass:"fill-height d-flex justify-center",attrs:{"fluid":""}},[_c('nuxt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }